// @file pro.js

if($("body").hasClass("page--pro")) {
  require('slick-carousel');

  class Pro {
    constructor() {
      let tooltip = require('../components/tooltip').tooltip;
      tooltip.init($(".js_plan-tool-tip"));
      this.$carouselElement = $('.js_pro-carousel');
      this.$faqHeading = $('.faqs-item__content-heading');
      this.attachCarousel($(window).width());
      this.attachEvent();
    }

    attachEvent() {
      $(window).resize(() => {
        this.attachCarousel($(window).width());
      });

      this.$faqHeading.on("click", (e) => {
        const $proFaqsText = $(e.currentTarget).next();

        let isOpen = $proFaqsText.is(':visible');

        if(isOpen) {
          $(e.currentTarget).removeClass("is_open");
        } else {
          $(e.currentTarget).addClass("is_open");
        }
        $proFaqsText.slideToggle("fast");
      });
    }

    attachCarousel(screenSize) {
      if(this.$carouselElement.hasClass("slick-initialized")) {
        return false;
      }
      if(screenSize <= 768) {
        this.$carouselElement.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          responsive: [
            {
              breakpoint: 2048,
              settings: "unslick"
            },
            {
              breakpoint: 768,
              settings: "slick"
            }
          ]
        });
      }
    }
  }

  new Pro();
}
